import { useQuery } from 'react-query'
import { message } from 'antd'
import { getApiRoles, getApiLogs } from 'utils/requests'
// helpers
import isNil from 'lodash/isNil'
import map from 'lodash/map'
import { useEffect } from 'react'

const useFetchData = (states, actions) => {
  const handlerRequest = useQuery<any>({
    queryKey: 'users-auth-data',
    queryFn: () => getApiLogs({
      is_fraudulent: false,
      page: states.page,
      search: states.searchInput,
      dateRange: {
        startDate: states.dates[0].format("YYYY-MM-DDTHH:mm:ss") + "Z",
        endDate: states.dates[1].format("YYYY-MM-DDTHH:mm:ss") + "Z"
      },
      filter: JSON.parse(isNil(states.filterSelected) ? "[]" : states.filterSelected),
      limit: 7
    }),
    initialData: [],
    select: ({ content: rawData, totalElements, ...rest }) => {

      return {
        data: map(rawData, ({ username, ...user }, i) => ({
          username,
          ...user,
          key: `${username}-${i}`
        })), total: totalElements
      }
    },
    onSuccess: () => {
      actions.setDirtyBit(false)
    },
    onError: () => {
      actions.setDirtyBit(false)
      message.error({
        type: 'error',
        content: 'Algo ha salido mal'
      })
    }
  })

  const { } = useQuery<any>({
    queryKey: 'roles-data',
    select: (rawData) => map(rawData, ({ id, ...data }) => ({ id, key: id, ...data })),
    queryFn: () =>
      getApiRoles(),
    initialData: [],
    onSuccess: (data) => {
      actions.setRoles(data)
    },
    onError: () => {

    }
  })

  useEffect(() => {
    states.dirtyBit && handlerRequest.refetch()
  }, [states.dirtyBit])

  return handlerRequest
}

export default useFetchData
